import axios from 'axios'

export default class AirBalticApi {
  constructor() {
    const config = useRuntimeConfig()
    axios.defaults.baseURL = config.public.airbalticApiUrl
    axios.defaults.timeout = 5000
  }

  async submitNewsletter(data: any) {
    try {
      const response = await axios.post(`/profile/subscribe/careers`, data)
      return await Promise.resolve(response.data)
    } catch (e) {
      return await Promise.reject(e)
    }
  }
}
